import React from 'react';

export default function DataTable({ columns = [], rows = [], compact = false, maxRows = 400 }) {
  const shown = rows.slice(0, maxRows);
  return (
    <div className={`le-table-wrap ${compact ? 'le-table-compact' : ''}`}>
      <table className="le-table">
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} className={c.align === 'right' ? 'num' : ''}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {shown.map((row, i) => (
            <tr key={row.__key ?? i}>
              {columns.map((c) => {
                const raw = row[c.key];
                const text = c.format ? c.format(raw, row) : (raw === null || raw === undefined ? '—' : String(raw));
                return <td key={c.key} className={c.align === 'right' ? 'num' : ''}>{text}</td>;
              })}
            </tr>
          ))}
          {shown.length === 0 ? (
            <tr><td colSpan={columns.length} className="le-table-empty">No rows</td></tr>
          ) : null}
        </tbody>
      </table>
      {rows.length > maxRows ? <div className="le-table-more">Showing first {maxRows} of {rows.length} rows</div> : null}
    </div>
  );
}
